import React, {useContext} from 'react';
import {NotificationsContext} from "../Contexts/contexts";

export function withNotifications(Component) {
    return function (props) {
        const notifications = useContext(NotificationsContext);
        return <Component {...notifications} {...props}/>
    }
}